<template>
    <div class="hero-logo" >
        <transition name="slide-fade" mode="in-out" >
            <div class="project-logo" :key="this.projectLogo" :style="resolveStyle()">
                <img :src=this.projectLogo >
            </div>
        </transition>
        
        <!-- <div class="divider"></div> -->
        <!-- <HeadlineBig 
            :headline=this.headline
        >
        </HeadlineBig> -->
    </div>

</template>

<script>
    import HeadlineBig from '@/components/typography/HeadlineBig.vue';

    export default {
        components: {
            HeadlineBig
        },
        props: {
            projectLogo: String,
            headline: String,
            label: String,
            layout: String,
            size: String
        },
        methods: {
            resolveStyle() {
                let style = " "
                if (this.layout == 'center-center') {
                    style = "top: 0; left: 50%; transform: translateX(-50%)"
                }

                if (this.layout == 'left-center') {
                    style = "top: 50%; left: 0; transform: translateY(-50%)"
                }

                if(this.size) {
                    style = style + " scale(" + this.size + ")"
                } else {
                    style = style + ";"
                }

                return style
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/scss/mixins.scss';
    .hero-logo {
        display: flex;
        position: relative;
        flex-direction: column;
        width: 55vw;
    }

    .project-logo {
        position: relative;
        padding: 2.5rem 1.5rem;
        text-align: center;
        max-height: 85vh;
        @include md () {
            top: 30% !important;
        }
        @include sm () {
            top: 25% !important;
        }
        & > img {
            object-fit: contain;
            width: 80%;
            height: 100%;
            object-fit: contain;
        }
    }

    .divider {
        height: 4.5rem;
        margin: 2.2rem 0; 
        width: 1px;
        background: #fff;
        display: inline-block;
    }
</style>

